import { CheckCircle, ArrowRight } from "lucide-react";
import { useLocation } from "wouter";

export default function PaymentSuccess() {
  const [, navigate] = useLocation();

  return (
    <div className="flex h-full min-h-[60vh] items-center justify-center p-6">
      <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-gray-900/5">
        <div className="bg-emerald-50 px-8 py-12 text-center sm:px-10">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 ring-8 ring-emerald-50">
            <CheckCircle className="h-10 w-10 text-emerald-600" />
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">Payment Successful!</h2>
          <p className="mt-3 text-base text-gray-600 leading-relaxed">
            Thank you! Your payment was processed successfully. You now have full access to Seismic Connect's premium features.
          </p>
        </div>
        <div className="bg-gray-50 px-8 py-8 text-center border-t border-gray-100">
          <button
            onClick={() => navigate("/")}
            className="group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 px-5 py-3.5 text-sm font-semibold text-white shadow-md transition-all hover:bg-emerald-700 active:scale-[0.98]"
          >
            Go to Dashboard
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </div>
  );
}
